// import qs from 'qs';
import request from '../utils/request'
export default {
  system: {

    /**
         * 登录-手机号密码
         * @date 2021-11-04
         * @param {any} params
         * @returns {any}
         */
    login: (params) => request.post('/api/auth/mobile_login', params),
    /**
         * 修改密码
         * @date 2022-04-28
         * @param {any} params
         * @returns {any}
         */
    resetpwd: (params) => request.post('/api/auth/update_password', params),
    /**
         * 登录-账号密码
         * @date 2022-03-21
         * @param {any} params
         * @returns {any}
         */
    loginpwd: (params) => request.post('/api/auth/name_login', params),

    /**
         * 登出
         * @date 2021-10-21
         * @returns {any}
         */
    logout: (params) => request.post('/api/auth/logout', params),

    /**
         * 登录-获取图形验证码
         * @date 2021-10-21
         * @returns {any}
         */
    captcha: () => request.get('/api/captcha'),
    /**
         * 学习园地
         * @date
         * @returns {any}
         */
    learn: (params) => request.get('/api/learning_garden', {
      params: params
    }),

    /**
         * 发送短信验证码
         * @date 2021-10-23
         * @returns {any}
         */
    sendSms: (params) => request.get('/api/message/send', {
      params: params
    }),

    /**
         * 注册
         * @date 2021-10-23
         * @param {any} params
         * @returns {any}
         */
    register: (params) => request.post('/api/auth/register', params),

    /**
         * 地区(省市区县联动)
         * @date 2021-12-14
         * @param {any} params
         * @returns {any}
         */
    areas: (params) => request.get('/api/areaList', {
      params: params
    }),

    /**
         * 微信登录
         * @date 2021-12-20
         * @returns {any}
         */
    wx: (params) => request.get('/api/wx/get_authorize_params', {
      params: params
    }),

    /**
         * 获取用户注册方式
         * @date 2022-01-04
         * @returns {any}
         */
    mode: (params) => request.get('/api/auth/get_register_mode', {
      params: params
    }),


    /**
         * 申请注册
         * @date 2022-02-14
         * @returns {any}
         */
    apply: (params) => request.post('/api/xt_school_apply_add', params)

  },
  proList: {
    create: {

      /**
             * 装备清单-添加单个工单
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      add: (params) => request.post('/api/set_xt_ticket', params)
    },
    retrieve: {

      /**
             * 装备清单 列表
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      data: (params) => request.get('/api/listing_list', {
        params: params
      }),

      /**
             * 装备清单 详情列表
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      dto: (params) => request.get('/api/listing_detail', {
        params: params
      })

    },
    update: {

      /**
             * 装备清单 导入单个
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      upload: (params) => request.post('/api/import_listingdetail', params)
    }
  },
  mine: {
    create: {

      /**
             * 点赞 添加
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      like: (params) => request.get('/api/add_like_num', {
        params: params
      }),

      /**
             * 收藏 添加
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      collect: (params) => request.post('/api/collection/add', params),

      /**
             * 内部用户 添加
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      user: (params) => request.post('/api/internalUsers/add', params),

      /**
             * 功能室 添加
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      room: (params) => request.post('/api/set_xt_func_room_edit', params),

      /**
             * 班级 添加
             * @date 2021-12-18
             * @param {any} params
             * @returns {any}
             */
      grade: (params) => request.post('/api/class/add', params),

      /**
             * 排课 添加
             * @date 2021-12-20
             * @param {any} params
             * @returns {any}
             */
      course: (params) => request.post('/api/classSchedule/add', params)
    },
    retrieve: {

      /**
             * 功能室 列表
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      room: (params) => request.get('/api/xt_func_room_list', {
        params: params
      }),

      /**
             * 内部用户 列表
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      user: (params) => request.get('/api/internalUsers/list', {
        params: params
      }),

      /**
             * 收藏 列表
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      collect: (params) => request.get('/api/collection/list', {
        params: params
      }),

      /**
             * 个人信息 详情
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      dto: (params) => request.post('/api/auth/me', params),
      /**
             * 班级 列表
             * @date 2021-12-18
             * @param {any} params
             * @returns {any}
             */
      grade: (params) => request.get('/api/class/list', {
        params: params
      }),

      /**
             * 排课 列表
             * @date 2021-12-20
             * @param {any} params
             * @returns {any}
             */
      course: (params) => request.get('/api/classSchedule/list', {
        params: params
      })
    },
    update: {

      /**
             * 内部用户信息 修改
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      user: (params) => request.post('/api/internalUsers/edit', params),

      /**
             * 功能室 绑定内部用户
             * @date 2021-12-18
             * @param {any} params
             * @returns {any}
             */
      lock: (params) => request.post('/api/func_room_bind', params),

      /**
             * 班级 修改
             * @date 2021-12-18
             * @param {any} params
             * @returns {any}
             */
      grade: (params) => request.post('/api/class/edit', params),

      /**
             * 排课 修改
             * @date 2021-12-20
             * @param {any} params
             * @returns {any}
             */
      course: (params) => request.post('/api/classSchedule/edit', params),

      /**
            * 登录后绑定、修改手机号
            * @date 2021-12-22
            * @param {any} params
            * @returns {any}
            */
      wx: (params) => request.post('/api/auth/bind_phone', params)

    },
    delete: {

      /**
             * 点赞 减少(不可用)
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      like: (params) => request.get('/api/del_like_num', {
        params: params
      }),

      /**
             * 收藏 取消
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      collect: (params) => request.get('/api/collection/remove', {
        params: params
      }),

      /**
             * 功能室 删除
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      room: (params) => request.get('/api/set_xt_func_room_delete', {
        params: params
      }),

      /**
             * 内部用户 删除
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      user: (params) => request.get('/api/internalUsers/del', {
        params: params
      }),

      /**
             * 班级 删除
             * @date 2021-12-18
             * @param {any} params
             * @returns {any}
             */
      grade: (params) => request.get('/api/class/delete', {
        params: params
      }),

      /**
             * 排课 删除
             * @date 2021-12-20
             * @param {any} params
             * @returns {any}
             */
      course: (params) => request.get('/api/classSchedule/delete', {
        params: params
      })
    }
  },
  library: {
    create: {

      /**
             * 图书馆在线申报 表单提交
             * @date 2021-12-27
             * @param {any} params
             * @returns {any}
             */
      data: (params) => request.post('/api/xt_library_declare/add', params),


      /**
             * 提交图片、视频
             * @date 2021-12-27
             * @param {any} params
             * @returns {any}
             */
      libraryMedia: (params) => request.post('/api/xt_library_declare/resource_add', params)

    },
    retrieve: {

      /**
             * 图书馆在线申报 状态
             * @date 2021-12-27
             * @param {any} params
             * @returns {any}
             */
      state: (params) => request.get('/api/xt_library_declare/status', {
        params: params
      }),

      /**
             * 图书馆在线申报 表单的配置
             * @date 2021-12-27
             * @param {any} params
             * @returns {any}
             */
      config: (params) => request.get('/api/xt_library_declare/option', {
        params: params
      }),

      /**
             * 图书馆在线申报 表单信息
             * @date 2021-12-27
             * @param {any} params
             * @returns {any}
             */
      data: (params) => request.get('/api/xt_library_declare/data', {
        params: params
      }),

      /**
             * 获取图片、视频列表
             * @date 2021-12-27
             * @param {any} params
             * @returns {any}
             */
      libraryMedia: (params) => request.get('/api/xt_library_declare/resource_list', {
        params: params
      }),

      /**
             * 图书馆 所支持的学校类型
             * @date 2022-01-07
             * @param {any} params
             * @returns {any}
             */
      about1: (params) => request.get('/api/xt_library_declare/xt_school_type', {
        params: params
      })
    },
    update: {

      /**
             * 图书馆在线申报 0撤销审核 1提交审核
             * @date 2021-12-27
             * @param {any} params
             * @returns {any}
             */
      state: (params) => request.get('/api/xt_library_declare/status_update', {
        params: params
      }),

      /**
             * 图书馆在线申报 撤销保存
             * @date 2022-02-14
             * @param {any} params
             * @returns {any}
             */
      submitState: (params) => request.get('/api/xt_library_declare/issave_update', {
        params: params
      })
    },
    delete: {

      /**
             * 图书馆在线申报 资源移除
             * @date 2021-12-27
             * @param {any} params
             * @returns {any}
             */
      libraryMedia: (params) => request.get('/api/xt_library_declare/resource_del', {
        params: params
      })
    }
  },
  room: {
    retrieve: {

      /**
            * 学校 教室列表
            * @date 2021-12-16
            * @param {any} params
            * @returns {any}
            */
      data: (params) => request.get('/api/get_xt_school_room_list', {
        params: params
      })
    }
  },
  school: {
    retrieve: {
      grade: (params) => request.get('/api/class/list', {
        params: params
      }),
      /**
             * 学校 列表筛选项
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      conditions: (params) => request.get('/api/xt_school_option', {
        params: params
      }),

      /**
             * 学校(又叫案例解析) 列表
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      data: (params) => request.get('/api/get_xt_school_list', {
        params: params
      }),

      /**
             * 学校 详情
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      dto: (params) => request.get('/api/xt_school_detail', {
        params: params
      }),

      /**
             * 学校 根据id获取学校名称
             * @date 2021-12-16
             * @param {any} params
             * @returns {any}
             */
      name: (params) => request.get('/api/get_xt_school_name', {
        params: params
      }),

      /**
             * 学校 文章
             * @date 2022-01-04
             * @param {any} params
             * @returns {any}
             */
      article: (params) => request.get('/api/xt_school_news_detail', {
        params: params
      })
    },
    update: {

      /**
             * 学校信息 修改
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      info: (params) => request.post('/api/set_xt_school_detail', params)

    }
  },
  square: {
    retrieve: {

      /**
             * 空间(又叫方案) 列表筛选项
             * @date 2021-12-14
             * @returns {any}
             */
      conditions: (params) => request.get('/api/design_option', {
        params: params
      }),

      /**
             * 空间 列表
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      data: (params) => request.get('/api/design_list', {
        params: params
      }),

      /**
             * 空间 列表补充数据
             * @date 2021-12-15
             * @param {any} params
             * @returns {any}
             */
      mock: (params) => request.get('/api/ds_teachingspace_list', {
        params: params
      }),

      /**
             * 空间 详情
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      dto: (params) => request.get('/api/design_detail', {
        params: params
      }),

      /**
             * 根据空间id 获取关联标准
            * @date 2021-10-09
            * @param {any} params
            * @returns {any}
            */
      about1: (params) => request.get('api/rec_wenku_by_design_id', {
        params: params
      }),

      /**
             * 学科 列表
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      subjects: (params) => request.get('/api/category_list', {
        params: params
      }),
      /**
             * 标准文档详情(根据方案id获取)
            * @date 2022-11-18
            * @param {any} params
            * @returns {any}
            */
      wenku: (params) => request.get('/api/rec_wenku_detail_by_design_id', {
        params: params
      })
    },
    update: {

      /**
             * 获取方案编辑页面iframe src
             * @date 2021-10-29
             * @param {any} params
             * @returns {any}
             */
      dto: (params) => request.get('/api/get_kjl_iframe_src', {
        params: params
      })
    }
  },
  notes: {
    retrieve: {

      /**
             * 消息通知 列表
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      notice: (params) => request.get('/api/guidance/list', {
        params: params
      }),

      /**
             * 消息通知 详情
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      noticeDto: (params) => request.get('/api/guidance/detail', {
        params: params
      }),

      /**
             * 消息通知 列表
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      message: (params) => request.get('/api/message/list', {
        params: params
      }),

      /**
             * 消息通知 详情
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      messageDto: (params) => request.get('/api/message/detail', {
        params: params
      }),

      /**
             * 消息通知 未读数量
             * @date 2022-02-28
             * @param {any} params
             * @returns {any}
             */
      messageNoNumber: (params) => request.get('/api/message/count', {
        params: params
      }),
      /**
       *   /**
             * 消息通知 未读数量
             * @date 2022-02-28
             * @param {any} params
             * @returns {any}
             */
      messageNoDetail: (params) => request.get('/api/message/detail', {
        params: params
      }),
      /**
             * 装备服务(又叫资讯) 类型
             * @date 2021-12-14
             * @returns {any}
             */
      informationTypes: () => request.get('/api/information_type'),

      /**
             * 装备服务 列表
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      information: (params) => request.get('/api/information_list', {
        params: params
      }),

      /**
             * 装备服务 详情
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      informationDto: (params) => request.get('/api/information_detail', {
        params: params
      }),

      /**
             * 消息-文库(又叫标准) 列表筛选项-类型
             * @date 2021-12-14
             * @returns {any}
             */
      standardTypes: () => request.get('/api/wenku_category'),

      /**
             * 消息-文库 列表
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      standard: (params) => request.get('/api/wenku_list', {
        params: params
      }),

      /**
             * 消息-文库 详情
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      standardDto: (params) => request.get('/api/wenku_detail', {
        params: params
      }),

      /**
             * 消息-文库 相关文库
             * @date 2021-10-09
             * @param {any} params
             * @returns {any}
             */
      standardAbout1: (params) => request.get('api/wenku_correlation', {
        params: params
      }),

      /**
             * 消息-文库 相关文库应用建议
            * @date 2021-10-09
            * @param {any} params
            * @returns {any}
            */
      standardAbout2: (params) => request.get('api/wenku_suggest', {
        params: params
      }),

      /**
             * 常见问题(又叫帮助中心) 类型
             * @date 2021-12-14
             * @returns {any}
             */
      helpTypes: () => request.get('/api/help_type'),

      /**
             * 常见问题 列表
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      help: (params) => request.get('/api/help_list', {
        params: params
      }),

      /**
             * 常见问题 详情
             * @date 2021-12-14
             * @param {any} params
             * @returns {any}
             */
      helpDto: (params) => request.get('/api/help_detail', {
        params: params
      })

    }
  },
  statistics: {
    /**
         * 装备统计-表格数据-模板
         * @date 2022-03-24
         * @param {any} params
         * @returns {any}
         */
    mode: (params) => request.get('/api/equip/option', {
      params: params
    }),

    /**
         * 装备统计-保存数据
         * @date 2022-03-24
         * @param {any} params
         * @returns {any}
         */
    submit: (params) => request.post('/api/equip/add', params),

    /**
         * 装备统计-获取当前用户状态
         * @date 2022-03-30
         * @param {any} params
         * @returns {any}
         */
    status: (params) => request.get('/api/equip/status', {
      params: params
    }),

    /**
         * 装备统计-修改用户状态
         * @date 2022-03-30
         * @param {any} params
         * @returns {any}
         */
    edit: (params) => request.get('/api/equip/status_update', {
      params: params
    }),

    /**
         * 装备统计-获取当前用户提交信息
         * @date 2022-03-30
         * @param {any} params
         * @returns {any}
         */
    data: (params) => request.get('/api/equip/data', {
      params: params
    }),
    /**
         * 装备统计-导入信息
         * @date 2022-04-28
         * @param {any} params
         * @returns {any}
         */
    import: (params) => request.post('/api/equip/import', params)
  }
}
